import * as React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import { EventLogger } from '../../extViewmodels';
import { BugsnagEventLogger } from '../../models/Logging';
import { AppHashHistory } from '../../web/constants/hash-history';
import { CancelMeetingPage } from '../containers/CancelMeetingPage';
import { ScheduleMeetingApp } from '../containers/ScheduleMeetingApp';
import { ScheduleMeetingLanding } from '../containers/ScheduleMeetingLanding';
import { LandingProvider } from '../contexts/landing';
import { MeetingProvider } from '../contexts/meeting';
import { ScheduleMeetingNotFound } from '../ScheduleMeetingNotFound';

export const ScheduleMeetingRouter: React.FC = () => {
	const bugsnagEventLogger = new BugsnagEventLogger(import.meta.env.MODE);
	const ErrorBoundary = bugsnagEventLogger.getErrorBoundary();
	EventLogger.addLogger(bugsnagEventLogger);

	const onRenderLanding = () => {
		return (
			<LandingProvider>
				<ScheduleMeetingLanding />
			</LandingProvider>
		);
	};

	const onRenderMeeting = () => {
		return (
			<MeetingProvider>
				<ScheduleMeetingApp />
			</MeetingProvider>
		);
	};

	const onRenderNotFound = () => {
		return <ScheduleMeetingNotFound />;
	};

	const onRenderCancelMeeting = () => {
		return <CancelMeetingPage />;
	};

	return (
		<ErrorBoundary>
			<Router history={AppHashHistory}>
				<Switch>
					<Route path='/:id/cancel' render={onRenderCancelMeeting} />
					<Route path='/landing/:shortCode' render={onRenderLanding} />
					<Route path='/team/:id' render={onRenderMeeting} />
					<Route path='/internal/:id' render={onRenderMeeting} />
					<Route path='/:shortCode/:vanityPath' render={onRenderMeeting} />
					<Route path='*' render={onRenderNotFound} />
				</Switch>
			</Router>
		</ErrorBoundary>
	);
};
